// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum TradingPositionType {
    MultiPosition = 0, // Hedging
    OnePosition = 1, // Net position by average price
    MultiPositionPerSide = 2,
    NotPositionByFIFO = 3,
};
